import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import Brand from '@/components/common/Brand';
import { WalletChip, AccountMenu, UnreadBadge } from '@/components/common/HeaderControls';

const NAV = [
  { to: '/', label: 'Home' },
  { to: '/#services', label: 'Services' },
  { to: '/companions', label: 'Companions' },
  { to: '/bookings', label: 'Bookings' },
  { to: '/messages', label: 'Messages' },
  { to: '/wallet', label: 'Wallet' },
];

export default function AppLayout() {
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-dvh flex-col bg-white text-ink antialiased">
      <header
        className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/95 backdrop-blur-md shadow-xs"
      >

        <div className="mx-auto flex max-w-6xl items-center gap-6 px-4 py-3.5 sm:px-6">
          <Brand to="/" />

          <nav className="hidden items-center gap-1 md:flex">
            {NAV.map((item) => {
              const active = item.to === '/' ? pathname === '/' : pathname.startsWith(item.to);
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={`rounded-lg px-3 py-2 text-sm font-semibold transition-colors duration-150 ${
                    active ? 'bg-brand-soft text-brand' : 'text-slate2 hover:text-navy'
                  }`}
                >
                  <span className="inline-flex items-center">
                    {item.label}
                    {item.to === '/messages' && <UnreadBadge />}
                  </span>
                </NavLink>
              );
            })}
          </nav>

          <div className="ml-auto flex items-center gap-3">
            <WalletChip />
            <AccountMenu />
          </div>
        </div>

        {/* Mobile bottom horizontal nav */}
        <nav className="flex gap-1 overflow-x-auto border-t border-slate-100 px-4 py-2 md:hidden">
          {NAV.map((item) => {
            const active = item.to === '/' ? pathname === '/' : pathname.startsWith(item.to);
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={`shrink-0 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors duration-150 ${
                  active ? 'bg-brand-soft text-brand' : 'text-slate2 hover:text-navy'
                }`}
              >
                <span className="inline-flex items-center">
                  {item.label}
                  {item.to === '/messages' && <UnreadBadge />}
                </span>
              </NavLink>
            );
          })}
        </nav>
      </header>

      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-8 sm:px-6 sm:py-10">
        <Outlet />
      </main>

      <footer className="border-t border-slate-100 bg-mist">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-4 py-6 sm:px-6">
          <p className="text-xs text-slate2">
            Verified activity companionship, not medical care. Partners and members are 18+ and verified.
          </p>
          <div className="flex gap-4 text-xs text-slate2">
            <Link to="/status" className="hover:text-navy">
              System status
            </Link>
            <Link to="/terms" className="hover:text-navy">
              Terms &amp; guidelines
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
